__turbopack_context__.v({
  "active": "style-module-scss-module__s0aJlW__active",
  "canceled": "style-module-scss-module__s0aJlW__canceled",
  "closed": "style-module-scss-module__s0aJlW__closed",
  "component": "style-module-scss-module__s0aJlW__component",
  "expired": "style-module-scss-module__s0aJlW__expired",
  "inactive": "style-module-scss-module__s0aJlW__inactive",
  "info-icon": "style-module-scss-module__s0aJlW__info-icon",
  "other": "style-module-scss-module__s0aJlW__other",
  "size-small": "style-module-scss-module__s0aJlW__size-small",
  "tooltip-trigger": "style-module-scss-module__s0aJlW__tooltip-trigger",
});
